import { IllustrationSize } from "@/constants/UI";
import { Button, FAIconName } from "@/ui/core";
import { Box, EmptyListBaseCard } from "@/ui/layout";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface ChannelListFooterProps extends BaseViewProps {
  onPress: () => void;
  shouldShowEmptyCard?: boolean;
}

const ChannelListFooter = ({
  onPress,
  shouldShowEmptyCard,
  testID,
}: ChannelListFooterProps) => {
  const baseTestID = joinTestIDs(testID, "about-messages");
  const buttonTitle = "Learn more about messages";

  if (shouldShowEmptyCard) {
    return (
      <EmptyListBaseCard
        buttonTitle="Learn More"
        description="You'll be able to message directly with providers on your team after you finish the admissions process and start treatment."
        iconHeight={IllustrationSize.Weight}
        iconName={IllustrationName.Message}
        iconWidth={IllustrationSize.Weight}
        onButtonPress={onPress}
        testID={joinTestIDs(testID, "learn-more")}
        title="At Equip, our providers are just a DM away"
      />
    );
  }

  return (
    <Box
      alignItems="center"
      backgroundColor={ColorToken.NeutralBackgroundPrimary}
      flexDirection="row"
      gap={8}
      onPress={onPress}
      paddingBottom={16}
      paddingHorizontal={16}
      paddingTop={8}
      testID={testID}
    >
      <Button
        accessibilityLabel={buttonTitle}
        leftIcon={FAIconName.InfoCircle}
        onPress={onPress}
        size="small"
        testID={baseTestID}
        title={buttonTitle}
        variant="tertiary"
      />
    </Box>
  );
};

export default ChannelListFooter;
